import { RouteProps } from "react-router-dom"
import Loadable from "../components/Loadable"

export interface AuthorityRouteProps extends RouteProps {
  requiredAuth?: boolean
}

const routes: AuthorityRouteProps[] = [
  {
    path: "/auth",
    exact: true,
    component: Loadable(() => import("../routes/Passport/Auth")),
    requiredAuth: false,
  },
  {
    path: "/logout",
    exact: true,
    component: Loadable(() => import("../routes/Passport/Logout")),
    requiredAuth: false,
  },
  {
    path: "/analysis/:dimension/:type",
    exact: true,
    component: Loadable(() => import("../routes/Analysis")),
    requiredAuth: true,
  },
  {
    path: "/",
    exact: false,
    component: Loadable(() => import("../routes/Entrance")),
    requiredAuth: true,
  },
]

export default routes
